@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';
@import '../../respond-to.scss';

@mixin subnavLink() {
  text-decoration: none;
  color: $color-gray-obsidian;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:link, &:visited, &:hover {
    color: $color-gray-obsidian;
  }
}

.ciMobileSubnav {
  visibility: hidden;

  &-mainMenu {
    list-style-type: none;
    padding: $spacing-8 0;
    font-size: $typography-body-short1-size;
    margin: 0;

    &-listItem {
      font-size: $typography-body-short2-size;
      display: block;
    }

    &-link {
      @include subnavLink();
      height: 40px;
      padding: $spacing-8 $spacing-16;
      position: relative;
      box-sizing: content-box;
    }
  }

  &-accordion {
    &-arrow {
      height: 20px;
      transition: all 0.25s;
      position: absolute;
      right: 1rem;
      top: 50%;
      transform: translateY(-50%);
      &--active {
        transform: translateY(-50%) rotate(90deg);
      }
    }
    &-menu {
      padding: 0 $spacing-16 $spacing-8 $spacing-16;
      list-style-type: none;
      font-size: $typography-body-short1-size;

      &-wrapper {
        max-height: 0;
        transition: all 200ms ease-in-out;
        overflow: hidden;
        &--active {
          max-height: 27.5rem;
        }
      }

      &-link {
        @include subnavLink();
        height: 24px;
        padding: $spacing-8 $spacing-16;
        box-sizing: content-box;
        &:hover {
          color: $color-blue-default;
        }
      }
      &-linkSolutions {
        text-decoration: none;
        color: $color-gray-obsidian;
        cursor: pointer;
        display: block;
        padding: .5rem .5rem .75rem .5rem;
        &:link, &:visited, &:hover {
          color: $color-gray-obsidian;
        }
        &-title, &-subtitle {
          display: block;
        }
        &-title {
          font-weight: 600;
          font-size: .9rem;
          margin-bottom: .2rem;
        }
      }
      &-linkSolutionsIcons {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        &-icon {
          width: 10%;
          img {
            display: block;
            width: 75%;
            height: auto;
          }
        }
        &-text {
          width: 90%;
        }
      }
      &--solutions {
        line-height: 1.2rem;
      }
    }
  }
  &-stores-pin {
    width: 20px;
    height: 20px;
  }
  &-stores-pin {
    width: 20px;
    height: 20px;
  }

  &-secondaryMenu {
    padding: $spacing-8 0;
    margin: 0;
    border-top: 1px solid $color-gray-accent;
    border-bottom: 1px solid $color-gray-accent;

    // to address safari bug
    &-listItem {
	    display: block;
    }

    &-link {
      @include subnavLink();
      height: 32px;
      justify-content: start;
      gap: $spacing-8;
      padding: $spacing-8 $spacing-16;
      font-size: $spacing-16;
      line-height: 125%;
      color: $color-gray-slate-dark;
      box-sizing: content-box;
    }
  }

  &-headset {
    width: 20px;
    color: $color-shade-white;
    padding-right: 6px;
  }
  &-chat {
    padding: $spacing-16;
    display: flex;
  }

  &-real-person {
    color: $color-red-default;
  }
}

@media only screen and (max-width: 1023px) {
  .ciMobileSubnav-mainMenu a:hover {
    color: $color-gray-obsidian;
  }
}

.tertiary-secondary-button {
  border: 1px solid $color-primary-default;
  border-radius: 6px;
  width: 100%;
  height: 44px;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: $color-primary-default;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
}
